import { ImgHTMLAttributes } from 'react'

import cn from '@/utils/tailwind/cn'

export const IntegrationCardImage = ({
  className,
  alt,
  ...props
}: ImgHTMLAttributes<HTMLImageElement>) => (
  <img alt={alt} className={cn('mr-3 h-8 w-8 rounded', className)} {...props} />
)
